document.addEventListener('DOMContentLoaded', function() {
    // Get all buttons with speedbump data attribute
    const buttons = document.querySelectorAll('.wp-block-button[data-speedbump="true"]');

    buttons.forEach(button => {
        // Create the popup structure inside the button div
        let popup = document.createElement('div');
        popup.className = 'speedbump-popup';
        popup.style.display = 'none'; // Start hidden
        popup.innerHTML = `
            <div class="speedbump-popup-content">
                <button id="close-popup" class="close-popup">&times;</button>
                <h3 class="h3 wdg-card__heading speedbump-title"></h3>
                <p class="speedbump-content"></p>
            </div>
        `;
        const speedbumpButtonText1 = button.getAttribute('data-speedbump-button-text-1');
        const speedbumpButtonText2 = button.getAttribute('data-speedbump-button-text-2');
             // Only add the buttons if the respective texts are present
        if (speedbumpButtonText1 || speedbumpButtonText2) {
            const buttonContainer = document.createElement('div');
            buttonContainer.className = 'speedbump-button-container';

            if (speedbumpButtonText1) {
                const button1 = document.createElement('div');
                button1.className = 'wp-block-button wp-block-button-1 wdg-card__button';
                button1.innerHTML = `<a class="wp-block-button__link wp-element-button" href=""></a>`;
                button1.querySelector('a').textContent = speedbumpButtonText1;
                button1.querySelector('a').href = button.getAttribute('data-speedbump-button-link-1');
                buttonContainer.appendChild(button1);
                button1.querySelector('a').addEventListener('click', function(event) {
                    event.preventDefault(); // Prevent default anchor behavior
                    const link1 = button.getAttribute('data-speedbump-button-link-1');
                    window.location.href = link1; // Navigate to the link
                });
            }

            if (speedbumpButtonText2) {
                const button2 = document.createElement('div');
                button2.className = 'wp-block-button wp-block-button-2 wdg-card__button';
                button2.innerHTML = `<a class="wp-block-button__link wp-element-button" href=""></a>`;
                button2.querySelector('a').textContent = speedbumpButtonText2;
                button2.querySelector('a').href = button.getAttribute('data-speedbump-button-link-2');
                buttonContainer.appendChild(button2);
                button2.querySelector('a').addEventListener('click', function(event) {
                    event.preventDefault(); // Prevent default anchor behavior
                    const link2 = button.getAttribute('data-speedbump-button-link-2');
                    window.location.href = link2; // Navigate to the link
                });
            }

            popup.querySelector('.speedbump-popup-content').appendChild(buttonContainer);
        }

        button.appendChild(popup); // Append the popup to the button div

        button.addEventListener('click', function(event) {
            const speedbumpContent = this.getAttribute('data-speedbump-content');
            const speedbumpTitle = this.getAttribute('data-speedbump-title');
            const speedbumpButtonText1 = button.getAttribute('data-speedbump-button-text-1');
            const speedbumpButtonLink1 = button.getAttribute('data-speedbump-button-link-1');
            const speedbumpButtonText2 = button.getAttribute('data-speedbump-button-text-2');
            const speedbumpButtonLink2 = button.getAttribute('data-speedbump-button-link-2');
            // Check if speedbump is enabled and if content is present
            if (this.getAttribute('data-speedbump') === 'true' && speedbumpContent ) {
                event.preventDefault(); // Prevent navigation

                // Set the popup content
                popup.querySelector('.speedbump-title').textContent = speedbumpTitle;
                if (/<a[^>]*>(.*?)<\/a>/.test(speedbumpContent)) {
                    // If it contains an anchor tag, set the innerHTML
                    popup.querySelector('.speedbump-content').innerHTML = speedbumpContent;
                } else {
                    // If no anchor tag, just set text content
                    popup.querySelector('.speedbump-content').textContent = speedbumpContent;
                }
                // Set button texts and links
                const button1 = popup.querySelector('.wp-block-button-1 a');
                if(button1) {
                    button1.textContent = speedbumpButtonText1;
                    button1.href = speedbumpButtonLink1;
                }
                
                const button2 = popup.querySelector('.wp-block-button-2 a');
                if(button2) {
                    button2.textContent = speedbumpButtonText2;
                    button2.href = speedbumpButtonLink2;
                }
                // Show the popup
                popup.style.display = 'flex'; // Display the popup

                // Add event listener for the close button
                const closePopup = popup.querySelector('#close-popup');
                closePopup.onclick = function(event) {
                    popup.style.display = 'none'; // Hide the popup on close
                    event.stopPropagation();
                };
            } else {
                // If speedbump is not enabled, navigate to the link
                window.location.href = this.querySelector('a').href;
            }
        });
    });
});
